module.exports = __webpack_public_path__ + "img/noto_coin.f790c70f.svg";